<ng-container *ngIf="!isLoading else showLoader">
    <acabim-datatable
        #categoryDataTable
        [dataSources]="dataTableSources"
        [dataKey]="'id'"
        (details)="setSelectedDetails($event)"
        (showDetail)="showDetails($event)"
        [hasDetailView]="true">
    </acabim-datatable>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button (click)="cancel()">Cancel</button>
        <button class="cas-button-action cas-button-right" (click)="add()">Add</button>
    </div>
</ng-container>

<acabim-modal
        [display]="loadDetails"
        [title]="'Editing: ' + dataTableSources[0]?.detailData?.name"
        (status)="closeDetailsModal($event)"
        fixHeight="60vh"
        width="60vw">
    <acabim-admin-work-order-category-details
        [workTypeData]="workType"
        [workCategoryData]="selectedDetails"
        (cancelled)="closeDetailsModal($event)"
        (completed)="completeDetailsModal($event)"></acabim-admin-work-order-category-details>
</acabim-modal>


<acabim-modal
        [display]="addWorkCategory"
        [title]="'Add work category'"
        (status)="closeAddModal($event)"
        fixHeight="60vh"
        width="60vw">
    <acabim-admin-work-order-category-details
        [workTypeData]="workType"
        (cancelled)="closeAddModal($event)"
        (completed)="completeAddModal($event)"></acabim-admin-work-order-category-details>
</acabim-modal>


<ng-template #showLoader>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
